export default __webpack_public_path__ + "static/media/Indoor-Outdoor-unit.d5307e27.jpg";